import { Injectable } from '@angular/core';
import { AlertController, AlertButton } from '@ionic/angular';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

export interface UpdateMessage {
  title: string;
  body: string;
}

export interface AppUpdate {
  under_maintenance: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class UpdateService {

  messages = {
    maintenance: {
      title: 'Maintenance',
      body: 'Nos serveurs sont actuellement en maintenance, veuillez nous excuser de ce désagrément',
    },
  };

  constructor(
    private alertController: AlertController,
    private httpClient: HttpClient,
  ) { }

  async checkForUpdate() {
    this.httpClient
      .get(`${environment.apiUrl}/application/${environment.application}`)
      .subscribe(async ({ under_maintenance }: AppUpdate) => {
        if (under_maintenance) {
          this.presentAlert(this.messages.maintenance);
        }
      });
  }

  async presentAlert(message: UpdateMessage, allowClose: boolean = false) {
    const buttons: AlertButton[] = [];

    if (allowClose) {
      buttons.push({
        text: 'Fermer',
        role: 'cancel'
      });
    }

    const alert = await this.alertController.create({
      header: message.title,
      message: message.body,
      buttons,
      backdropDismiss: allowClose
    });

    await alert.present();
  }
}
